export const AUTH_STORAGE_KEY = "bs:auth";
const LEGACY_LOCAL_STORAGE_KEY = AUTH_STORAGE_KEY;

let memoryAuth = null;

function getWindowStorage(kind) {
  if (typeof window === "undefined") return null;
  try {
    const storage = kind === "local" ? window.localStorage : window.sessionStorage;
    const probe = "__auth_storage_probe__";
    storage.setItem(probe, "1");
    storage.removeItem(probe);
    return storage;
  } catch {
    return null;
  }
}

function getPersistenceMode() {
  const raw = String(process.env.REACT_APP_AUTH_PERSISTENCE || "session").trim().toLowerCase();
  return raw === "local" ? "local" : "session";
}

function getPrimaryStorage() {
  return getWindowStorage(getPersistenceMode());
}

function getLegacyStorage() {
  return getWindowStorage("local");
}

function normalizeStoredAuth(value) {
  if (!value || typeof value !== "object") return null;
  const token = typeof value.token === "string" && value.token.trim() ? value.token.trim() : null;
  const me = value.me && typeof value.me === "object" ? value.me : null;
  if (!token && !me) return null;
  return { token, me };
}

function parseStoredAuth(raw) {
  if (!raw) return null;
  try {
    return normalizeStoredAuth(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function readStoredAuth() {
  const primary = getPrimaryStorage();
  const fromPrimary = parseStoredAuth(primary?.getItem(AUTH_STORAGE_KEY));
  if (fromPrimary) return fromPrimary;

  if (memoryAuth) return normalizeStoredAuth(memoryAuth);

  const legacy = getLegacyStorage();
  const fromLegacy = parseStoredAuth(legacy?.getItem(LEGACY_LOCAL_STORAGE_KEY));
  if (fromLegacy) {
    writeStoredAuth(fromLegacy);
    if (getPersistenceMode() !== "local") {
      try {
        legacy?.removeItem(LEGACY_LOCAL_STORAGE_KEY);
      } catch {}
    }
    return fromLegacy;
  }

  return null;
}

export function writeStoredAuth(value) {
  const normalized = normalizeStoredAuth(value);
  memoryAuth = normalized;
  const primary = getPrimaryStorage();
  try {
    if (!primary) return;
    if (!normalized) primary.removeItem(AUTH_STORAGE_KEY);
    else primary.setItem(AUTH_STORAGE_KEY, JSON.stringify(normalized));
  } catch {}
}

export function clearStoredAuth() {
  memoryAuth = null;
  try {
    getPrimaryStorage()?.removeItem(AUTH_STORAGE_KEY);
  } catch {}
  try {
    getLegacyStorage()?.removeItem(LEGACY_LOCAL_STORAGE_KEY);
  } catch {}
}

export function readAuthToken() {
  return readStoredAuth()?.token || null;
}

export function updateStoredAuthToken(token) {
  const current = readStoredAuth();
  if (!current) return;
  writeStoredAuth({ ...current, token: token || null });
}
